module.exports = __webpack_public_path__ + "img/field1.5f2188b9.png";